import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  PageEvent,
} from '@angular/material';

import { fromEvent, Subscription } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
} from 'rxjs/operators';
import Swal from 'sweetalert2';

import {
  SearchPatientReq,
  SearchPatientRes,
} from 'src/app/core/model/v2/practice/searchPatientList';
import { Patient } from 'src/app/core/models/patient/patient';
import {
  PractitionerDocument,
} from 'src/app/core/models/practitioner/practitioner-document';
import { CommonService } from 'src/app/core/services/v2/common.service';
import {
  PreviewDocumentComponent,
} from 'src/app/shared/components/preview-document/preview-document.component';

import { PracticeService } from '../../core/services/v2/practice.service';
import {
  WindowLoaderService,
} from '../../shared/components/window-loader/window-loader.service';
import { SidebarPhysicianEditComponent } from 'src/app/physician/profile/physician/sidebar-physician-edit/sidebar-physician-edit.component';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
import { AddNewMemberComponent } from '../add-new-member/add-new-member.component';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { MemberService } from 'src/app/core/services/v2/shared-member-search.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PatientMinimum } from 'src/app/core/model/patient';
import { PDFDialogComponent } from 'src/app/signup-organization/pdf-dialog/pdf-dialog.component';
// import { PatientMinimum } from 'src/app/core/model/patient';

@Component({
  selector: "app-members-search",
  templateUrl: "./members-search.component.html",
  styleUrls: ["./members-search.component.scss"],
})
export class MembersSearchComponent implements OnInit, AfterViewInit {
  uploadedFile: PractitionerDocument;
  userId: number;
  toggleSidebar = false;
  sectionName: string = "referPatient";
  togglePatientProfileSidebar = this.commonService.togglePatientProfileSidebar;
  searchCriteria: string = "";
  showPatientProfile: boolean = false;
  pageLength = 10;
  pageIndex = 1;
  dataLength;
  activeId: number;
  searchData: Patient[];
  openSection: string;
  user: any = [];
  employeeId: number;
  healthOrganizationId:number;
  patient: PatientMinimum;
  currentUserId: number;
  originalData: any[] = []; // Store original data for filtering
employerId:number;
  displayedColumns: string[] = [
    // "checkbox",
    "patientName",
    "email",
    //"gender",
    // "contact",
    "userId",
    "lastLoginDate",
    "actions"
    // "aptDateTime",
    // "nextAptDateTime",
    // "symptoms",
    // "action",
  ];
  dataSource: SearchPatientRes[];
  role: string;
  selectedPatient: Patient;
  selection = new SelectionModel<any>(true, []);
  sideBarHeader: string;
  file: File | null = null;
  private subscription: Subscription;

  isUploading: boolean = false;
  @ViewChild(SidebarPhysicianEditComponent, { static: false })
  childComponent: SidebarPhysicianEditComponent;
  @ViewChild("patientSearchInput", { static: true })
  patientSearchInput: ElementRef;
  @ViewChild('fileInput',{static:false}) fileInput!: any;
  constructor(
    private practiceService: PracticeService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private employerService: EmployerService,
    private memberService: MemberService,
    private patientsService: PatientService,
    private _utils: UtilsService,
    private _userService: UserService,

    
    
  ) { }

  changeIndex(event: PageEvent) {
    this.pageLength = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.searchPatient();
  }

  // ngOnInit() {
  //   this.getUserDetails()
  //   // console.log(this.physicianOptionService.getPhysician().userId);
  //   // this.physicianOptionService.selectionChange$.subscribe(
  //   //   (_) => {
  //   //     this.searchCriteria = "";
  //   //     this.searchPatient();
  //   //   },
  //   //   (error) => {
  //   //     console.error(error);
  //   //   }
  //   // );
  //   this.subscription = this.memberService.refreshMembers$.subscribe(() => {
  //     this.searchPatient(); // Trigger searchPatient when event is received
  //   });

  //   this.searchPatient();

  //   fromEvent(this.patientSearchInput.nativeElement, "keyup")
  //     .pipe(
  //       map((event: any) => {
  //         return event.target.value;
  //       }),
  //       debounceTime(500),
  //       distinctUntilChanged()
  //     )
  //     .subscribe((text: string) => {
  //       this.searchCriteria = text;
  //       this.searchPatient();
  //     });
  // }
  ngOnInit() {
    this.isUploading = false;
    this.employeeId = 0;
    this.patient = <PatientMinimum>{};
    console.log(this.physicianOptionService.getPhysician().userId);
    this.physicianOptionService.selectionChange$.subscribe(
      (_) => {
        this.searchCriteria = "";
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      }
    );
    fromEvent(this.patientSearchInput.nativeElement, "keyup")
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.searchCriteria = text;
        this.searchPatient();
      });
      this.getUserDetails();
      // this.getCurrentPatientDetails();
  }
  // ngAfterViewInit() {
  //   // this.searchPatient();
  // }
  ngAfterViewInit() {
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.currentUserId = userDetails.id;
        this.searchPatient();
      },
      (error) => {
        console.error(error);
      },
      () => {
        //   this.loaderService.hide();
      }
    );

  }
  togglePatientSidebar(element) {
    this.selectedPatient = element;
    this.openSection = 'profile';
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }

  togglePatientHealthHistory(element) {
    this.selectedPatient = element;
    this.openSection = 'healthHistory';
    this.togglePatientProfileSidebar = !this.togglePatientProfileSidebar;
    this.showPatientProfile = !this.showPatientProfile;
  }
toggleEditSidebar(
    sectionName: string,
    patient: Patient,
    sideBarHeader: string
  ) {

    if (sectionName !== 'close') {
      this.sectionName = sectionName;
      if (this.sectionName == "communicateMultiplePatient") {
        //this.selection.select(...this.dataSource);
        this.selection = new SelectionModel<SearchPatientRes>(true, [...this.dataSource])
      }
      this.sideBarHeader = sideBarHeader;
      this.activeId = patient && patient.id ? patient.id : undefined;
      this.selectedPatient = patient;
      this.showHideScroll(this.toggleSidebar);
    }
    this.toggleSidebar = !this.toggleSidebar;
    // this.destroyChild();
  }

  togglePopUp() {
    // this.practitionerData = pracdata;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    // this.destroyChild();
  }

  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector("body");
    if (isOpen) {
      body.style.cssText = "height:100vh; overflow:hidden";
    } else {
      body.style.cssText = "height:auto; overflow:visible";
    }
  }

  // destroyChild() {
  //   if (this.childComponent) {
  //     this.childComponent.ngOnDestroy();
  //   }
  // }
  // ngOnDestroy() {
  //   this.subscription.unsubscribe();
  // }
  // getUserDetails() {
  //   // this.loaderService.show();
  //   this._userService.getUserDetails().subscribe(
  //     (result) => {
  //       this.user = result;
  //       this.searchPatient();

  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  // }
  getUserDetails() {
    this.loaderService.show();
    this._userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        this.healthOrganizationId = userDetails.healthOrganizationId;

        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        console.log("This is healthOrganizationId: ", this.healthOrganizationId);

        // this.getEmployerHealthSubscriptionByEmployerId();

      },
      (error) => { console.error(error); }
    );
  }
  // searchPatient() {
  //   const searchReq: SearchPatientReq = new SearchPatientReq();
  //   // searchReq.userId = this.physicianOptionService.getPhysician().userId;
  //   searchReq.healthOrganizationId = this.user.healthOrganizationId;
  //   searchReq.employerId = null;

  //   searchReq.pageIndex = this.pageIndex;
  //   searchReq.itemsCount = this.pageLength;
  //   searchReq.criteria = this.searchCriteria;

  //   if (searchReq.healthOrganizationId) {
  //     this.loaderService.show();
  //     this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
  //       (res) => {
  //         this.searchData = res.patients;
  //         this.dataSource = res.patients.filter(x => !x.employerId);
  //         this.dataLength = res.totalRecords;
  //         if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
  //           this.pageIndex = 1;

  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //       },
  //       () => {
  //         this.loaderService.hide();
  //       }
  //     );
  //   }
  // }
  searchPatient() {
    const searchReq: SearchPatientReq = new SearchPatientReq();
    searchReq.userId = this.currentUserId;
    searchReq.pageIndex = this.pageIndex;
    searchReq.itemsCount = this.pageLength;
    searchReq.criteria = this.searchCriteria;
    searchReq.parenttype = "employer";
    searchReq.employerId = this.employerId;
    searchReq.healthOrganizationId = this.healthOrganizationId;

    if (searchReq.healthOrganizationId) {
      this.loaderService.show();
      this.practiceService.GetPatientsListByOrgId(searchReq).subscribe(
        (res) => {
          this.originalData = res.patients;  // Store the full data
          this.dataSource = [...this.originalData];  // Copy full data to dataSource
          this.searchData = res.patients;
          // this.dataSource = res.patients;
          this.dataLength = res.totalRecords;
          if (this.dataLength < (this.pageIndex - 1) * this.pageLength)
            this.pageIndex = 1;
          this.loaderService.hide();
        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        },
        () => {
          this.loaderService.hide();
        }
      );
    }
  }
  getPractitionerPatientDocument() {
    this.practiceService
      .getPractitionerPatientDocument(
        this.physicianOptionService.getPhysician().id
      )
      .subscribe((res) => {
        this.uploadedFile = res;
        console.log(this.uploadedFile);
      });
  }

  attachFile(event) {
    let file: File;
    if (event[0]) {
      file = event[0];
    } else {
      file = event.target.files[0];
    }

    this.practiceService
      .uploadPractitionerPatientDocument(
        this.physicianOptionService.getPhysician().id,
        file
      )
      .subscribe((res) => console.log(res));
  }

  deleteFile(file) {
    this.practiceService
      .deletePractitionerPatientDocument(file.id)
      .subscribe((res) => console.log(res));
  }

  viewFile(file: File) {
    const dialogRef = this.dialog.open(PreviewDocumentComponent, {
      id: "view-dialog",
      width: "90%",
      height: "90%",
      hasBackdrop: true,
      disableClose: true,
      backdropClass: "preview-modal",
      data: { documentLocation: file, isFrame: true },
    });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource);
  }

  openAddNewMemberDialog() {
    const newMemberDialog = this.dialog.open(AddNewMemberComponent, {
      width: "52%",
      data: { isFromAdmin: true,title: "Member"}
    });
    newMemberDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.searchPatient();
      }
    });
  }

  // Handle file selection
//   onFileChange(event: Event): void {
//    const input = event.target as HTMLInputElement;
 
//    if (input && input.files && input.files.length > 0) {
//      this.file = input.files[0]; // Store the selected file
//      this.uploadFile();  // Automatically trigger file upload when file is selected

//    }
//  }
//  // Upload the file to the API
// uploadFile(): void {
//   if (!this.file) {
//     alert('Please select a file first');
//     return;
//   }
//  console.log(this.file)
//  this.isUploading = true; // Set uploading flag to true

//   // Create a FormData object to send the file
//   const formData = new FormData();
//   formData.append('employeeDataSource', this.file);
//   console.log(formData)
//   // Debug: Log FormData content
//   // formData.forEach((value, key) => {
//   //   console.log(`${key}:`, value);
//   // });
//   // Call the API with FormData

//   this.employerService.bulkUploadEmployeeData(formData).subscribe(
//     (res) => {
//       console.log('Upload successful:', res);
//         // Assign the response array directly to the dataSource
//         // this.searchData = res;
//         this.dataSource = res;

//         // Optionally configure displayedColumns if needed
//         this.displayedColumns = ['patientName', 'contact'];
//       this.isUploading = false;  // Set uploading flag to false after success
//     },
//     (error) => {
//       console.error('Upload error:', error);
//       this.isUploading = false;  // Set uploading flag to false on error
//     }
//   );
// }
handleFileClick(){
  if(this.fileInput && this.fileInput.nativeElement && this.fileInput.nativeElement.value)
  this.fileInput.nativeElement.value = '';
if(this.file)
  this.file = null;
  this.fileInput.nativeElement.click();
}


onFileChange(event: Event, employerId: number): void {
  const input = event.target as HTMLInputElement;

  if (input && input.files && input.files.length > 0) {
    this.file = input.files[0]; // Store the selected file
    this.uploadFile(employerId); // Automatically trigger file upload when file is selected
  }
}

uploadFile(employerId: number): void {
  if (!this.file) {
     this._utils.showMessageSnackBar('Please select a file first',true);
    return;
  }
  this.isUploading = true; // Set uploading flag to true
  // Create a FormData object to send the file and employerId
  const formData = new FormData();
  formData.append('employeeDataSource', this.file);
  //formData.append('employerId', employerId.toString()); // Append employerId to FormData
  // Call the API with FormData
  this.loaderService.show();
  this.employerService.bulkUploadEmployeeData(formData).subscribe(
    (res) => {
      this.loaderService.hide();
      this._utils.showMessageSnackBar(JSON.stringify(res));    
      this.isUploading = false; // Set uploading flag to false after success
      this.searchPatient();
    },
    (error) => {
      this.loaderService.hide();
      this._utils.showMessageSnackBar(error.error,true);
      this.isUploading = false; // Set uploading flag to false on error
    }
  );
}

  // deleteEmployee(id: number) {
  //   // patient.active = false;
  //   console.log("userId",id)
  //   Swal.fire({
  //     title: `Delete Employee`,
  //     text: `Are you sure want to delete this Employee?`,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Yes, Delete!'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.loaderService.blockWithLoader(this.patientsService.deleteMemberPatients(id)).subscribe(
  //         (res) => {
  //           if (res.isSuccess) {
  //             // this.searchPatient();
  //             this._utils.showMessageSnackBar('Employee deleted successfully.');
  //           }
  //         },
  //         (error) => { console.error(error); },
  //       )
  //     }
  //   })

  // }
   deleteEmployee(patient: Patient) {
      patient.active = false;
      Swal.fire({
        title: `Delete Employee`,
        text: `Are you sure want to delete this Employee?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loaderService.blockWithLoader(this.patientsService.updatePatientDetails(patient)).subscribe(
            (res) => {
              if (res.isSuccess) {
                this.searchPatient();
                this._utils.showMessageSnackBar('Employee deleted successfully.');
              }
            },
            (error) => { console.error(error); },
          )
        }
      })
  
    }
    downloadFile() {
      const fileUrl = 'assets/pdf/Member_Census_Template.xlsx'; // Correct path to your assets folder
      const anchor = document.createElement('a');
      anchor.href = fileUrl;
      anchor.download = 'Member_Census_Template.xlsx'; // The file name for download
      anchor.click();
      anchor.remove(); // Clean up the created element
    
    }
    
    openInstructionFile() {
      const pdfUrl = 'assets/pdf/MEMBER_CENSUS_TEMPLATE_INSTRUCTIONS.pdf';
      const windowFeatures = 'width=800,height=600,scrollbars=yes,resizable=yes';
      window.open(pdfUrl, 'PDFWindow', windowFeatures);
    }
    openPdf() {
      let data = {
        title: 'Member Template Instructions',
        filename: 'MEMBER_CENSUS_TEMPLATE_INSTRUCTIONS.pdf',
      }
    
    
      this.dialog.open(PDFDialogComponent, { panelClass:'member-template-modal', id: 'member_template', data: { ...data, isBack: false, } });
    }
}
